export default class GetWorkTypeGroupByIdError extends Error {

}
